var _g, _rect, _path, _line, _line2, _line3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 77,
    viewBox: "0 0 69 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5247_14158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 56V25C17.2734 22.2386 19.512 20 22.2734 20H39.3942L50 29.4408V56C50 58.7614 47.7614 61 45 61H22.2734C19.512 61 17.2734 58.7614 17.2734 56Z",
    fill: "#F2F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 29.4408V56C50 58.7614 47.7614 61 45 61H22.2734C19.512 61 17.2734 58.7614 17.2734 56V25C17.2734 22.2386 19.512 20 22.2734 20H39.3942M50 29.4408L39.3942 20M50 29.4408H44.3942C41.6327 29.4408 39.3942 27.2022 39.3942 24.4408V20",
    stroke: "#4A9BFF",
    strokeWidth: 3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27,
    width: 27,
    height: 13,
    rx: 4,
    fill: "#4A9BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6456 37V30.4545H17.1001C17.603 30.4545 18.0249 30.5483 18.3658 30.7358C18.7088 30.9233 18.9677 31.1811 19.1424 31.5092C19.3192 31.8352 19.4077 32.206 19.4077 32.6214C19.4077 33.0412 19.3192 33.4141 19.1424 33.7401C18.9656 34.0661 18.7045 34.3228 18.3594 34.5103C18.0142 34.6957 17.5891 34.7884 17.0842 34.7884H15.4574V33.8136H16.9244C17.2184 33.8136 17.4592 33.7624 17.6467 33.6602C17.8342 33.5579 17.9727 33.4173 18.0621 33.2383C18.1538 33.0593 18.1996 32.8537 18.1996 32.6214C18.1996 32.3892 18.1538 32.1847 18.0621 32.0078C17.9727 31.831 17.8331 31.6935 17.6435 31.5955C17.456 31.4954 17.2141 31.4453 16.918 31.4453H15.8313V37H14.6456ZM23.1556 37H20.9376V30.4545H23.2004C23.8502 30.4545 24.4085 30.5856 24.8751 30.8477C25.3438 31.1076 25.7039 31.4815 25.9553 31.9695C26.2068 32.4574 26.3325 33.0412 26.3325 33.7209C26.3325 34.4027 26.2057 34.9886 25.9521 35.4787C25.7007 35.9687 25.3374 36.3448 24.8623 36.6069C24.3893 36.869 23.8204 37 23.1556 37ZM22.1233 35.9741H23.0981C23.5541 35.9741 23.9344 35.891 24.2391 35.7248C24.5438 35.5565 24.7728 35.3061 24.9262 34.9737C25.0796 34.6392 25.1563 34.2216 25.1563 33.7209C25.1563 33.2202 25.0796 32.8047 24.9262 32.4744C24.7728 32.142 24.5459 31.8938 24.2455 31.7298C23.9472 31.5636 23.5764 31.4805 23.1333 31.4805H22.1233V35.9741ZM27.9591 37V30.4545H32.1523V31.4485H29.1448V33.2255H31.8646V34.2195H29.1448V37H27.9591Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 45,
    x2: 42.9845,
    y2: 45,
    stroke: "#A3B8CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 49.541,
    x2: 42.9845,
    y2: 49.541,
    stroke: "#A3B8CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 54.084,
    x2: 37.5342,
    y2: 54.084,
    stroke: "#A3B8CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5247_14158",
    x: 0.773438,
    y: 0.5,
    width: 67.7266,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5247_14158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5247_14158",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfL);
export default __webpack_public_path__ + "static/media/pdf_l.c66d624888181b73ed4da57c01162800.svg";
export { ForwardRef as ReactComponent };